var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a-card", { attrs: { bordered: false } }, [
    _c(
      "div",
      { staticClass: "table-page-search-wrapper" },
      [
        _c(
          "a-form",
          { attrs: { layout: "inline" } },
          [
            _c(
              "a-row",
              { attrs: { gutter: 24 } },
              [
                _c(
                  "a-col",
                  { attrs: { span: 3 } },
                  [
                    _c(
                      "a-form-item",
                      { attrs: { label: "年级" } },
                      [
                        _c("j-dict-select-tag", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择年级",
                            dictCode:
                              "school_grade,grade_name,id,0=delete_flag order by sort_order",
                            allowClear: "",
                          },
                          on: {
                            change: _vm.handleGradeChange,
                            clear: _vm.handleGradeChange,
                            input: _vm.handleGradeChange,
                          },
                          model: {
                            value: _vm.queryParam.gradeId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParam, "gradeId", $$v)
                            },
                            expression: "queryParam.gradeId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 3 } },
                  [
                    _c(
                      "a-form-item",
                      { attrs: { label: "班级" } },
                      [
                        _c("j-dict-select-tag", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: !_vm.queryParam.gradeId,
                            placeholder: "请选择班级",
                            dictCode:
                              "school_class,name,id,grade_id=" +
                              (!_vm.queryParam.gradeId
                                ? -1
                                : _vm.queryParam.gradeId),
                            async: true,
                          },
                          model: {
                            value: _vm.queryParam.classId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParam, "classId", $$v)
                            },
                            expression: "queryParam.classId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-item",
                      { attrs: { label: "学生名称" } },
                      [
                        _c("a-input", {
                          model: {
                            value: _vm.queryParam.studentName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParam, "studentName", $$v)
                            },
                            expression: "queryParam.studentName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "a-form-item",
                      { attrs: { label: "处理状态" } },
                      [
                        _c(
                          "a-select",
                          {
                            attrs: { allowClear: "" },
                            model: {
                              value: _vm.queryParam.dealType,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParam, "dealType", $$v)
                              },
                              expression: "queryParam.dealType",
                            },
                          },
                          [
                            _c("a-select-option", { attrs: { value: "0" } }, [
                              _vm._v("未处理"),
                            ]),
                            _c("a-select-option", { attrs: { value: "1" } }, [
                              _vm._v("已处理"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 5 } },
                  [
                    _c(
                      "a-form-item",
                      { attrs: { label: "时间范围" } },
                      [
                        _c("a-range-picker", {
                          attrs: { value: _vm.rangeDate },
                          on: { change: _vm.onRangeChange },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("a-col", { attrs: { span: 4 } }, [
                  _c(
                    "span",
                    {
                      staticClass: "table-page-search-submitButtons",
                      staticStyle: { float: "left", overflow: "hidden" },
                    },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "search" },
                          on: {
                            click: function ($event) {
                              return _vm.loadData(1)
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "table-operator" },
      [
        _c(
          "a-button",
          {
            attrs: {
              type: "primary",
              icon: "download",
              loading: _vm.exportXlsLoading,
            },
            on: {
              click: function ($event) {
                return _vm.handleExportXlss("学生提醒清单")
              },
            },
          },
          [_vm._v("\n      导出\n    ")]
        ),
      ],
      1
    ),
    _c(
      "div",
      [
        _c("a-table", {
          ref: "table",
          staticClass: "j-table-force-nowrap",
          attrs: {
            size: "middle",
            scroll: { x: true },
            bordered: "",
            rowKey: "id",
            columns: _vm.columns,
            dataSource: _vm.dataSource,
            loading: _vm.loading,
            pagination: _vm.ipagination,
          },
          on: { change: _vm.handleTableChange },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }